var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataBackup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509.287 509.287",
    style: {
      enableBackground: "new 0 0 509.287 509.287"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4F5565",
      opacity: 0
    },
    cx: 254.644,
    cy: 254.644,
    r: 254.644
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9C9C"
    },
    d: "M420.111,106.469H87.142c-7.799,0-14.241,6.442-14.241,14.241v223.788 c0,7.799,6.442,14.241,14.241,14.241h332.97c7.799,0,14.241-6.442,14.241-14.241V120.71 C434.352,112.911,427.91,106.469,420.111,106.469z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.906,
    y: 125.457,
    style: {
      fill: "#FFFFFF"
    },
    width: 321.102,
    height: 213.955
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9C9C"
    },
    d: "M38.993,358.739c0,24.413,19.666,44.079,44.079,44.079h342.803c24.413,0,44.079-19.666,44.079-44.079 H38.993z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.358,
    y: 366.538,
    style: {
      fill: "#DEDEDF"
    },
    width: 112.572,
    height: 14.241
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4485C5"
    },
    d: "M319.746,231.926C319.407,231.926,319.407,231.926,319.746,231.926 c-1.695-14.919-13.902-26.448-29.16-27.126c-6.103-22.379-26.448-38.993-50.861-38.993c-29.16,0-52.895,23.735-52.895,52.895 c0,4.747,0.678,9.155,1.695,13.563c-0.339,0-0.678,0-1.017,0c-18.649,0-33.907,15.258-33.907,33.907 c0,18.31,14.58,33.229,32.89,33.907l0,0h132.917c18.649,0,33.907-15.258,33.907-33.907 C353.653,247.184,338.395,231.926,319.746,231.926z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0582F"
    },
    points: "279.396,260.747 253.626,234.977 227.857,260.747 238.368,260.747 238.368,322.797  268.546,322.797 268.546,260.747 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBackup);
export default __webpack_public_path__ + "static/media/DataBackup.ced28941f74651863a05d1fb557ae7e4.svg";
export { ForwardRef as ReactComponent };